import { Icon } from '@/components/ui/icon';
import { cn } from '@/lib/core/utils/cn';

interface QuantityStepperProps {
  value: number;
  min?: number;
  max?: number;
  onChange: (v: number) => void;
  disabled?: boolean;
  /** Spreads the − / value / + across the full width instead of clustering them together. */
  fullWidth?: boolean;
}

export function QuantityStepper({
  value,
  min = 0,
  max = 99,
  onChange,
  disabled,
  fullWidth,
}: QuantityStepperProps) {
  const atMin = value <= min;
  const atMax = value >= max;

  return (
    <div className={cn('flex items-center', fullWidth && 'w-full justify-between')}>
      <button
        type="button"
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={disabled || atMin}
        className={cn(
          'flex size-11 shrink-0 cursor-pointer items-center justify-center rounded-full',
          (disabled || atMin) && 'opacity-40'
        )}
        aria-label="Decrease"
      >
        <Icon name="minus" width={24} height={24} strokeWidth={1.5} className="text-jncquoi-neutral-1000" />
      </button>

      <div className="font-pp-neue-montreal w-15 p-2 text-center text-[14px] tracking-[0.5px] text-[#1a1a1a]">
        {String(value).padStart(2, '0')}
      </div>

      <button
        type="button"
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={disabled || atMax}
        className={cn(
          'flex size-11 shrink-0 cursor-pointer items-center justify-center rounded-full',
          (disabled || atMax) && 'opacity-40'
        )}
        aria-label="Increase"
      >
        <Icon name="plus" width={24} height={24} strokeWidth={1.5} className="text-jncquoi-neutral-1000" />
      </button>
    </div>
  );
}
